import A11yScanner from 'umg-ember-backend/components/record-detail/for/a11y-scanner';

<template><A11yScanner @model={{@model}} /></template>
